import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import routes from './routes';
import { Provider } from 'react-redux';
import store, { history } from './store/store';
import { CookiesProvider } from 'react-cookie';
import { polyfill } from 'scroll-behaviour';
polyfill();
import { hashLinkScroll } from './helpers/superScroll';
import './styles/scss/main.scss';


ReactDOM.render(
    <CookiesProvider>
        <Provider store={store}>
            <Router history={history} routes={routes}
                onUpdate={hashLinkScroll}
            />
        </Provider>
    </CookiesProvider>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// src/client/index.js